<iframe
    #chatFrame
    [src]="sanitizedChatURL"
    [ngClass]="open ? 'opened' : 'closed'"
    [hidden]="isLoading"
    allow="camera; microphone"
    frameBorder="0"
    class="chat-iframe"
></iframe>